import { createSlice } from "@reduxjs/toolkit";

import { InitialState, UpClientProfileInterface } from "../../types/clientData";

import { 
    STORAGE_KEY_USER_PROFILE
} from "../../constants/global"

const storedUser = localStorage.getItem(STORAGE_KEY_USER_PROFILE)

const initialState: InitialState = {
    login: !storedUser? false : true,
    clientInfo: {
        _id: "",
        firstName: "",
        lastName: "",
        email: "",
        newPassword: "",
    } as UpClientProfileInterface
}; 

export const clientDataSlice = createSlice({
    name: "clientData",
    initialState: initialState,
    reducers: {
        logIn: (state, action) => {
            localStorage.setItem(STORAGE_KEY_USER_PROFILE, action.payload.token)
            state.login = true;
        },
        upToken: (state, action) => {
            localStorage.setItem(STORAGE_KEY_USER_PROFILE, action.payload.token)
        },
        setClientInfo: (state, action) => {
            state.clientInfo = action.payload
        },
        logOut: (state, action) => {
            localStorage.removeItem(STORAGE_KEY_USER_PROFILE)
            state.login = false;
        },
    },
});

export const { 
    logIn, 
    upToken,
    setClientInfo,
    logOut 
} = clientDataSlice.actions;

export default clientDataSlice.reducer;